import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { utcToZonedTime } from 'date-fns-tz';

import { AdaptiveTableCell } from '@components/common';

import { formatDate } from '@utils/kpi-utils/date';

import { formatTemplateWithTime, timezoneUTC } from '@constants/common';
import { columnSizes } from '@constants/table';

export const getColumns = () => ([
	{
		header: 'USER NAME',
		accessorKey: 'requesterName',
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return (
				<AdaptiveTableCell text={value} />
			);
		},
	},
	{
		header: 'ACTION',
		accessorKey: 'action',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return (
				<AdaptiveTableCell text={value} />
			);
		},
	},
	{
		header: 'ROLE',
		accessorKey: 'changedBy.roles',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();
			let text = '';

			value?.forEach((role: any, index: number) => {
				if (index === value.length - 1) text += `${role.title}`;
				else text += `${role.title}, `;
			});

			return (
				<AdaptiveTableCell text={text} />
			);
		},
	},
	{
		header: 'ACTION DATE',
		accessorKey: 'createdAt',
		size: columnSizes.size185,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();
			const date = formatDate(utcToZonedTime(value, timezoneUTC), formatTemplateWithTime);

			return (
				<AdaptiveTableCell text={date} />
			);
		},
	},
]);

export const getPlatformOwnerColumns = () => ([
	{
		header: 'ACTION',
		accessorKey: 'action',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return (
				<AdaptiveTableCell text={value} />
			);
		},
	},
	{
		header: 'ACTION DATE',
		accessorKey: 'createdAt',
		size: columnSizes.size185,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();
			const date = formatDate(utcToZonedTime(value, timezoneUTC), formatTemplateWithTime);

			return (
				<AdaptiveTableCell text={date} />
			);
		},
	},
]);
